<template>
  <section class="row">
    <div class="col-9 mx-auto">
      <div class="h5">
        Formule de garantie
      </div>
      <div class="text-gray-600 my-3">
        Vous pouvez valider votre modification et passer à la signature des
        déclarations, ou bien poursuivre vos modifications.
      </div>
    </div>
    <div class="col-12 col-md-9 mx-auto">
      <div
        v-for="liability in liabilities"
        :key="liability.id"
      >
        <div class="row">
          <div class="col-12 col-md-4 d-flex flex-md-row flex-column">
            <div class="d-flex flex-column flex-md-row m-auto">
              <label class="form-check-label m-auto">
                <input
                  :id="liability.id"
                  class="form-check-input"
                  type="radio"
                  :checked="liability.enabled"
                  @click="set(liability.id, !liability.enabled)"
                >
              </label>
              <div class="d-flex flex-column ms-md-2 col-md">
                <div class="fw-bold mb-1 text-center">
                  {{ liability.name }}
                </div>
                <div
                  class="badge rounded-pill text-gray-700"
                  :class="liability.enabled ? 'bg-yellow-500' : 'bg-gray-300'"
                >
                  + {{ liability.monthlyPremium | formatPrice(true) }} € / mois
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8 mt-2 mt-md-0 text-center text-md-start">
            <p
              class="mb-0"
              v-html="liability.description"
            />
            <p
              class="fw-bold"
              v-html="liability.shortDescription"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'EditionFormula',
  props: {
    contract: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      checked: null,
    };
  },
  computed: {
    liabilities() {
      if (this.contract) {
        return this.contract.liabilities || [];
      }
      return [];
    },
  },
  methods: {
    set(liabilityId, value) {
      const newLiabilities = this.liabilities
        .map((elem) => ({ ...elem, enabled: false }))
        .map((elem) => (elem.id === liabilityId ? {
          ...elem,
          enabled: value,
        } : elem));
      this.$store.dispatch('contract/updateSubscription', {
        value: newLiabilities,
        path: 'liabilities',
      });
    },
  },
};
</script>
